import React from 'react';

type StatusTone = 'good' | 'warn' | 'bad' | 'neutral';

const TONE_CLASS: Record<StatusTone, string> = {
  good: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  warn: 'bg-amber-100 text-amber-700 border-amber-200',
  bad: 'bg-rose-100 text-rose-700 border-rose-200',
  neutral: 'bg-slate-100 text-slate-700 border-slate-200',
};

const resolveTone = (status: string): StatusTone => {
  const normalized = status.trim().toLowerCase();
  if (['active', 'enrolled', 'verified', 'good standing', 'sent', 'posted'].includes(normalized)) return 'good';
  if (['pending', 'in-progress', 'in progress', 'scheduled', 'prospective', 'under review'].includes(normalized)) return 'warn';
  if (['withdrawn', 'archived', 'failed', 'missing signature', 'voided'].includes(normalized)) return 'bad';
  return 'neutral';
};

export const StudentsFamiliesStatusBadge = ({ status }: { status: string }) => {
  const tone = resolveTone(status);
  return (
    <span
      data-testid="students-families-status-badge"
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${TONE_CLASS[tone]}`}
    >
      {status}
    </span>
  );
};
